import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';
import { View } from 'dripsy';

import { useCallback, useContext, useEffect, useState } from 'react';
import { UpdateCardKycAccountIndividual } from '@/features/account-management/screens/Kyc-info/CardKycInfoUpdate';
import { CardKycInfoPlaced } from './CardKycInfoPlaced';

import { UpdateCardKycStackRoutes, UpdateCardKycStackParamList, UpdateCardKycStackScreenProps } from './type';
import { ModalContainerView } from '@/features/account-management/components/ModalContainerView';

const UpdateCardKycStack = createNativeStackNavigator<UpdateCardKycStackParamList>();

export const UpdateCardAccountKycInfo: React.FC<UpdateCardKycStackScreenProps<UpdateCardKycStackRoutes.Individual>> = ({ route }) => {
  const { func, data:initData, refresh, onChangeView, onBackData } = route.params;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const layout = useContext(LayoutContext);

  useEffect(() => {
    if (!layout.isMobile) return;
    setDimensions(layout.dimensions);
  }, [layout.dimensions]);

  const [data, setData] = useState(initData);
  const onData = (data: any) => {
    setData(data);
  };

  const onLayout = useCallback((event) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  }, []);

  const [returnData, setReturnData] = useState(undefined);
  const onReturnData = (data: any) => {
    setReturnData(data);
  };

  const compareData = (data: any, initData: any) => {
    const result: any = {};
    for (const key in data) {
      if (typeof data[key] === 'object') {
        const temp = compareData(data[key], initData[key]);
        if (Object.keys(temp).length > 0) {
          result[key] = temp;
        }
      } else {
        // HACK return is string, sumbmit is number
        if (data[key] != initData[key]) {
          result[key] = data[key];
        }
      }
    }
    return result;
  };

  return (
    <ModalContainerView dimensions={dimensions}>
      <View sx={{ height: dimensions.height, width: dimensions.width }} onLayout={onLayout}>
        <UpdateCardKycStack.Navigator
          initialRouteName={UpdateCardKycStackRoutes.Individual}
          screenOptions={{
            presentation: layout.isMobile ? 'modal' : 'transparentModal',
            headerShown: false
          }}>
          <UpdateCardKycStack.Screen
            name={UpdateCardKycStackRoutes.Individual}
            component={UpdateCardKycAccountIndividual}
            initialParams={{ onLayout, data, onData, func, onReturnData, refresh, onChangeView, onBackData, initData, compareData }}
            options={{
              presentation: layout.isMobile ? 'modal' : 'transparentModal',
              headerShown: false
            }}
          />
          <UpdateCardKycStack.Screen
            name={UpdateCardKycStackRoutes.Placed}
            component={CardKycInfoPlaced}
            initialParams={{ onLayout, data, returnData, refresh }}
            options={{ presentation: layout.isMobile ? 'modal' : 'transparentModal', headerShown: false }}
          />
        </UpdateCardKycStack.Navigator>
      </View>
    </ModalContainerView>
  );
};